import { render, staticRenderFns } from "./DialogPersonalizado.vue?vue&type=template&id=cb015260&"
import script from "./DialogPersonalizado.vue?vue&type=script&lang=js&"
export * from "./DialogPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports